export const COLORS = {
  0: "#061C3F",
  1: "#1589EE",
  2: "#FFB75D",
  3: "#B620E0",
  review: "#4BCA81",
  available: "#FFB75D",
  custom: "#FA6400",
};
